import { createTheme } from '@mui/material/styles';
import tokens from './tokens';

const { color, font, radius, shadow } = tokens;

const muiTheme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: color.brand, dark: color.brandDark, light: color.brandLight, contrastText: '#fff' },
    secondary: { main: color.ink, light: color.inkSoft, contrastText: '#fff' },
    success: { main: color.success },
    warning: { main: color.warning },
    error: { main: color.danger },
    info: { main: color.info },
    background: { default: color.bg, paper: color.surface },
    text: { primary: color.text, secondary: color.textMuted },
    divider: color.border,
  },
  shape: { borderRadius: radius.md },
  typography: {
    fontFamily: font.body,
    h1: { fontFamily: font.display, fontWeight: 700, letterSpacing: '0.01em' },
    h2: { fontFamily: font.display, fontWeight: 700, letterSpacing: '0.01em' },
    h3: { fontFamily: font.display, fontWeight: 700 },
    h4: { fontFamily: font.display, fontWeight: 700, fontSize: '2rem' },
    h5: { fontFamily: font.display, fontWeight: 700, fontSize: '1.5rem' },
    h6: { fontWeight: 700, fontSize: '1.05rem' },
    subtitle1: { fontWeight: 600 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  components: {
    // No celular, os avisos aparecem acima da barra de atalhos do rodapé
    MuiSnackbar: {
      styleOverrides: {
        root: {
          '@media (max-width:899.95px)': {
            '&.MuiSnackbar-anchorOriginBottomCenter, &.MuiSnackbar-anchorOriginBottomLeft, &.MuiSnackbar-anchorOriginBottomRight': {
              bottom: 'calc(80px + env(safe-area-inset-bottom))',
            },
          },
        },
      },
    },
    MuiCssBaseline: { styleOverrides: { body: { backgroundColor: color.bg } } },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: { root: { borderRadius: radius.sm, paddingInline: 16 } },
    },
    MuiCard: {
      defaultProps: { elevation: 0 },
      styleOverrides: { root: { border: `1px solid ${color.border}`, borderRadius: radius.lg, boxShadow: shadow.sm } },
    },
    MuiPaper: { styleOverrides: { rounded: { borderRadius: radius.lg } } },
    MuiDialog: { styleOverrides: { paper: { borderRadius: radius.lg } } },
    MuiDialogTitle: { styleOverrides: { root: { fontWeight: 700, fontSize: '1.15rem' } } },
    MuiTextField: { defaultProps: { size: 'medium' } },
    MuiTableCell: {
      styleOverrides: {
        head: { fontWeight: 700, color: color.textMuted, backgroundColor: color.surfaceAlt, textTransform: 'uppercase', fontSize: '0.72rem', letterSpacing: '0.04em' },
      },
    },
    MuiTab: { styleOverrides: { root: { textTransform: 'none', fontWeight: 600, minHeight: 48 } } },
    MuiChip: { styleOverrides: { root: { fontWeight: 600 } } },
    MuiAlert: { styleOverrides: { root: { borderRadius: radius.md } } },
    MuiDataGrid: {
      styleOverrides: {
        root: { border: `1px solid ${color.border}`, borderRadius: radius.md, backgroundColor: color.surface },
        columnHeaders: { backgroundColor: color.surfaceAlt, color: color.textMuted, fontWeight: 700 },
      },
    },
  },
});

export default muiTheme;
